import { env, Env } from "./environment";

// Presentation only: these labels must never select a backend or storage namespace.
// Production is the product users install, so it keeps the plain "Ideaflow" name and shows no environment badge;
// only non-production environments are labeled.
const identities: Record<Env, { name: string; badge: string | null; manifest: string }> = {
  [Env.prod]: { name: "Ideaflow", badge: null, manifest: "/manifest.json" },
  [Env.dev]: { name: "Ideaflow Dev", badge: "Dev", manifest: "/manifest-dev.json" },
  [Env.preview]: { name: "Ideaflow Preview", badge: "Preview", manifest: "/manifest-preview.json" },
  [Env.local]: { name: "Ideaflow Local Dev", badge: "Local Dev", manifest: "/manifest-local.json" },
};

export const appIdentity = identities[env];
